import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Overview from "./Overview";
import Students from "./Students";
import Opportunities from "./Opportunities";
import TimeLogs from "./TimeLogs";
import Reports from "./Reports"; // Import the Reports component

const AdminDashboard = () => {
  const [activePage, setActivePage] = useState("Overview");
  // eslint-disable-next-line
  const [currentOpportunity, setCurrentOpportunity] = useState(null);

  // Function to handle viewing the opportunity
  const handleViewOpportunity = (opportunityId) => {
    // Example: Set the current opportunity (you can fetch opportunity details here)
    console.log("Viewing opportunity with ID:", opportunityId);
    setCurrentOpportunity(opportunityId);
  };

  const renderPage = () => {
    switch (activePage) {
      case "Overview":
        return <Overview />;
      case "Students":
        return <Students onViewOpportunity={handleViewOpportunity} />;
      case "Opportunities":
        return <Opportunities />;
      case "Time Logs":
        return <TimeLogs />;
      case "Reports":
        return <Reports />; // Render the Reports component
      default:
        return <Overview />;
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <Sidebar activePage={activePage} setActivePage={setActivePage} />
      <div className="flex-1 p-4 md:p-6 bg-gray-50">{renderPage()}</div>
    </div>
  );
};

export default AdminDashboard;
